var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('WebsocketData',{attrs:{"url-input":[_vm.websocketURL]},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var outData = ref.outData;
return [(outData[_vm.websocketURL])?_c('v-row',_vm._l((_vm.params),function(fieldName){return _c('v-col',[_c('p',[_vm._v(" "+_vm._s(outData[_vm.websocketURL][fieldName]))])])}),1):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }